<template>
  <footer>
    <div class="footer-container">
      <div class="footer-info">
        <a href="/home.html#ABOUT">About us</a>
        <span class="separator">|</span>
        <a href="/home.html#WHY">Why us</a>
        <span class="separator">|</span>
        <a href="/blog/">BLOG</a>
      </div>

      <div class="footer-info">
        <a href="/policies.html#privacy">Privacy Policy</a>
        <span class="separator">|</span>
        <a href="/policies.html#terms">Terms of Service</a>
        <span class="separator">|</span>
        <a href="/policies.html#refund">Return & Refund</a>
        <span class="separator">|</span>
        <a href="/policies.html#shipping">Shipping Policy</a>
      </div>

      <div class="footer-info">
        <a href="mailto:info@customteamkit.com">info@customteamkit.com</a>
        <span class="separator">|</span>
        <a href="tel:+8613537631227">+86 135 3763 1227</a>
      </div>



      <div class="footer-copyright">
        © {{ currentYear }} Custom Team Kit. Shenzhen Hongxin Technology Co., Ltd. All rights reserved.
      </div>
    </div>
  </footer>  
</template>

<script setup>
import { computed } from 'vue'

const currentYear = computed(() => new Date().getFullYear())
</script>

<style scoped>
footer {
  background: #212529;
  color: white;
  text-align: center;
  padding: 1.5rem 0 1rem;
  margin-top: 2rem;
  position: relative;
  clear: both;
  z-index: 10;
}

.footer-container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
}

.footer-info {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 0.75rem;
  font-size: 0.9rem;
}

.footer-info a {
  color: white;
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-info a:hover {
  color: #3b82f6;
}

.separator {
  color: #555;
  user-select: none;
}

.social-icons {
  display: flex;
  justify-content: center;
  gap: 1.2rem;
  margin-bottom: 0.75rem;
  margin-top: 0.5rem;
}

.social-icons a {
  color: white;
  font-size: 1.4rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-block;
}

.social-icons a:hover {
  transform: translateY(-2px) scale(1.08);
}

.social-icons a[aria-label="WhatsApp"]:hover { color: #25d366; }
.social-icons a[aria-label="Facebook"]:hover { color: #1877f2; }
.social-icons a[aria-label="Instagram"]:hover { color: #e1306c; }

.footer-copyright {
  font-size: 0.8rem;
  color: #888;
  margin-top: 0.5rem;
}

@media (max-width: 900px) {
  footer {
    margin-top: 60px;
  }
}

@media (max-width: 768px) {
  .footer-info {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.8rem;
  }
  .separator {
    display: inline;
    color: #444;
  }
  .social-icons {
    gap: 1.2rem;
  }
  .social-icons a {
    font-size: 1.3rem;
  }
  footer {
    margin-top: 80px;
  }
}

@media (max-width: 480px) {
  footer {
    margin-top: 100px;
  }
}
</style>